module.exports = __webpack_public_path__ + "img/Boy_020033.d6cec3ed.png";